import {
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Box,
  LinearProgress,
} from "@mui/material";
import { t } from "i18next";
import WhatshotIcon from "@mui/icons-material/Whatshot";

type WordBarElememtProps = {
  word: string;
  scaledNumber: number;
  color?:
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning"
    | "inherit";
  icon?: any;
  barWidth?: number;
  fontSize?: number
};

export function WordBarElement(props: WordBarElememtProps) {
  var width = props.barWidth ? props.barWidth + "%" : "40%"
  var fontSize = props.fontSize ? props.fontSize + "px" : "14px"
  var secondaryFontSize = props.fontSize ? (props.fontSize - 1) + "px" : "12px"
  return (
    <ListItem
      className="grey-hover minor-scale-up-hover"
      style={{ paddingTop: "0px", paddingBottom: "0px" }}
    >
      <ListItemAvatar>
        <Avatar
          style={{
            background: "none",
            width: "24px",
            height: "24px",
            margin: "auto",
          }}
        >
          {props.icon ? props.icon : <WhatshotIcon />}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={props.word}
        primaryTypographyProps={{
          fontSize: fontSize,
        }}
        secondary={
          t("keyword:popularity") + ": " + Math.round(props.scaledNumber)
        }
        secondaryTypographyProps={{ fontSize: secondaryFontSize }}
      />
      <Box sx={{ width: {width}, marginRight: "20px" }}>
        <LinearProgress
          variant="determinate"
          color={props.color ? props.color : "success"}
          value={props.scaledNumber}
        />
      </Box>
    </ListItem>
  );
}
